import { ConnectionStateEnum } from '@core/model/domain/bankConnection';
import { Mapper } from '@core/model/framework/mapper';
import { injectable } from 'inversify';

@injectable()
export class BankConnectionStateMapper implements Mapper<ConnectionStateEnum, string> {
  toDomain(state: string): ConnectionStateEnum {
    switch (state) {
      case ConnectionStateEnum.VALID:
        return ConnectionStateEnum.VALID;
      case ConnectionStateEnum.SCA:
        return ConnectionStateEnum.SCA;
      case ConnectionStateEnum.DECOUPLED:
        return ConnectionStateEnum.DECOUPLED;
      case ConnectionStateEnum.MORE_INFORMATION:
        return ConnectionStateEnum.MORE_INFORMATION;
      case ConnectionStateEnum.ACTION_NEEDED:
        return ConnectionStateEnum.ACTION_NEEDED;
      case ConnectionStateEnum.ERROR:
        return ConnectionStateEnum.ERROR;
      case ConnectionStateEnum.PASSWORD_EXPIRED:
        return ConnectionStateEnum.PASSWORD_EXPIRED;
      case ConnectionStateEnum.VALIDATING:
        return ConnectionStateEnum.VALIDATING;
      case ConnectionStateEnum.WEBAUTH_REQUIRED:
        return ConnectionStateEnum.WEBAUTH_REQUIRED;
      default:
        throw new Error('unexpected value');
    }
  }
}
